import React from 'react';
import { Messages } from '../../translations/message.models';

export interface StepCardProps {
  stepNumber: number;
  title: string;
  messages: Messages;
  children?: React.ReactNode;
}

const StepCard = ({ stepNumber, title, messages, children }: StepCardProps) => (
  <section
    className="c-ssa-create-quiz-step-card"
    aria-labelledby={`ssa-create-quiz-step-title-${stepNumber}`}
    data-testid={`ssa-create-quiz-step-card-${stepNumber}`}
  >
    <h2 className="c-ssa-create-quiz-step-card__heading u-els-font-size-h4" id={`ssa-create-quiz-step-title-${stepNumber}`}>
      <span className="c-ssa-create-quiz-step-card__number" data-testid={`ssa-create-quiz-step-number-${stepNumber}`}>
        <span className="u-els-hide-visually">{messages.STEP} </span>
        {stepNumber}
      </span>
      <span className="c-ssa-create-quiz-step-card__title" data-testid={`ssa-create-quiz-step-title-${stepNumber}`}>{title}</span>
    </h2>
    <div className="c-ssa-create-quiz-step-card__content">
      {children}
    </div>
  </section>
);

export default StepCard;
